import { useEffect } from 'react';

import { setDeviceWidth_DANGER_INTERNAL } from '../../features/uiSlice.ts';
import { useAppDispatch } from '../../hooks.ts';
import { DeviceWidth } from '../../types.ts';
import { DESKTOP_MAX_WIDTH, PHONE_MAX_WIDTH, TABLET_MAX_WIDTH } from './consts.ts';

const matchesPhone = matchMedia(`screen and (max-width: ${PHONE_MAX_WIDTH}px)`);
const matchesTablet = matchMedia(
  `screen and (min-width: ${PHONE_MAX_WIDTH + 1}px) and (max-width: ${TABLET_MAX_WIDTH}px)`,
);
const matchesDesktop = matchMedia(
  `screen and (min-width: ${TABLET_MAX_WIDTH + 1}px) and (max-width: ${DESKTOP_MAX_WIDTH}px)`,
);
const matchesUnconstrained = matchMedia(`screen and (min-width: ${DESKTOP_MAX_WIDTH + 1}px)`);

const listenerFactory =
  (deviceWidth: DeviceWidth, dispatch: ReturnType<typeof useAppDispatch>) =>
  (listEvent: MediaQueryListEvent) => {
    if (listEvent.matches) {
      dispatch(setDeviceWidth_DANGER_INTERNAL({ deviceWidth }));
    }
  };

export const useDeviceWidth_DANGER_INTERNAL = (): void => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const phoneListener = listenerFactory('phone', dispatch);
    const tabletListener = listenerFactory('tablet', dispatch);
    const desktopListener = listenerFactory('desktop', dispatch);
    const unconstrainedListener = listenerFactory('unconstrained', dispatch);

    matchesPhone.addEventListener('change', phoneListener);
    matchesTablet.addEventListener('change', tabletListener);
    matchesDesktop.addEventListener('change', desktopListener);
    matchesUnconstrained.addEventListener('change', unconstrainedListener);

    return () => {
      matchesPhone.removeEventListener('change', phoneListener);
      matchesTablet.removeEventListener('change', tabletListener);
      matchesDesktop.removeEventListener('change', desktopListener);
      matchesUnconstrained.removeEventListener('change', unconstrainedListener);
    };
  }, [dispatch]);
};
